import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, takeUntil } from 'rxjs';
import { UtilsService } from '../lib/utils.service';

@Injectable()
export class CancelInterceptor implements HttpInterceptor {

  constructor(private utilsService: UtilsService) { }

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(req).pipe(takeUntil(this.utilsService.onCancelPendingRequests()))
  }
}
